
import { Badge } from '@/components/ui/badge';

const BrokerageUseCases = () => {
  const useCases = [
    "Enterprises negotiating campus connectivity",
    "Colo clients wanting to hold their own carrier contracts", 
    "Clients tired of getting ghosted by Tier 1 sales reps",
    "Startups needing reliable connectivity without legal traps",
    "Clients needing help with IP strategy + justification",
    "Proxy operators scaling global or regional footprints"
  ];

  return (
    <section className="py-16 bg-gray-50 section-wave">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Who This Is For
          </h2>
          <p className="text-xl text-gray-600">
            Perfect for organizations that need real connectivity expertise
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {useCases.map((useCase, index) => (
            <Badge 
              key={index} 
              variant="outline" 
              className="p-4 text-center text-sm border-nexx-green/30 bg-white hover:bg-nexx-green/5 transition-colors h-auto"
            >
              {useCase}
            </Badge>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BrokerageUseCases;
